export const trendsExportConfig = {
  page: { key: 'trends', title: 'Trends Dashboard' },
  sections: [
    { key: 'base', title: '' },
    {
      key: 'summary-panel',
      title: 'Summary Panel',
      order: ['summary-widget', 'dod-summary-widgets'],
    },
    {
      key: 'alerts-panel',
      title: 'Alerts',
      order: [
        'ai-alert-summary',
        'ai-alert-series',
        'ai-alert-all-events',
        'manual-alert-summary',
        'manual-alert-all-events',
      ],
    },
    {
      key: 'compare-panel',
      title: 'Compare Filters',
      order: [],
    },
    {
      key: 'metrics-panel',
      title: 'Metrics Panel',
      order: ['primary-timeseries', 'mf-timeseries', 'distribution', 'dod-timeseries'],
    },
    {
      key: 'diagnostics-panel',
      title: 'Diagnostics Panel',
      order: ['diag-timeseries', 'compare-diag-timeseries', 'diag-distribution'],
    },
    {
      key: 'dimensions-panel',
      title: 'Dimensions Panel',
      order: ['dimension-table', 'viewer-sessions', 'impacted-viewers'],
    },
    {
      key: 'annotations',
      title: 'Annotations',
    },
  ],
};

export const appEventsExportConfig = {
  page: { key: 'trends', title: 'Trends Dashboard' },
  sections: [
    { key: 'base', title: '' },
    {
      key: 'summary-panel',
      title: 'Summary Panel',
      order: ['summary-widget', 'dod-summary-widgets'],
    },
    {
      key: 'alerts-panel',
      title: 'Alerts',
      order: [
        'ai-alert-summary',
        'ai-alert-series',
        'ai-alert-all-events',
        'manual-alert-summary',
        'manual-alert-all-events',
      ],
    },
    {
      key: 'compare-panel',
      title: 'Compare Filters',
      order: [],
    },
    {
      key: 'metrics-panel',
      title: 'Metrics Panel',
      order: ['timeseries', 'mf-timeseries', 'distribution', 'dod-totals'],
    },
    {
      key: 'diagnostics-panel',
      title: 'Diagnostics Panel',
      order: ['diag-timeseries', 'compare-diag-timeseries', 'diag-distribution'],
    },
    {
      key: 'dimensions-panel',
      title: 'Dimensions Panel',
      order: ['dimension-table', 'viewer-sessions', 'network-request', 'network-request-rca'],
    },
    {
      key: 'annotations',
      title: 'Annotations',
    },
  ],
};

export const metricLensExportConfig = {
  page: { key: 'metriclens', title: 'Metric Lens Dashboard' },
  sections: [
    { key: 'ml-base', title: '' },
    {
      key: 'ml-content',
      title: '',
      order: ['table', 'timeseries'],
    },
  ],
};

export const manualAlertExportConfig = {
  page: { key: 'manual-alert-events', title: 'Manual Alert Event List' },
  sections: [
    {
      key: 'alert',
      title: 'Alert',
      order: ['table'],
    },
    {
      key: 'events',
      title: 'Events',
      order: ['table'],
    },
  ],
};
